export default {
  test: {
    name: "testsss",
    list: "list",
  },
};
